import { render, staticRenderFns } from "./VaccinationDonutChartPanel.vue?vue&type=template&id=e9f5c5ce&scoped=true&"
import script from "./VaccinationDonutChartPanel.vue?vue&type=script&lang=js&"
export * from "./VaccinationDonutChartPanel.vue?vue&type=script&lang=js&"
import style0 from "./VaccinationDonutChartPanel.vue?vue&type=style&index=0&id=e9f5c5ce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9f5c5ce",
  null
  
)

export default component.exports